module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('loading', {
    attrs: {
      "show": _vm.showProcessing,
      "label": "Processing"
    }
  }), _vm._v(" "), _c('overview-layout', {
    ref: "overview",
    attrs: {
      "tableCfg": _vm.tableCfg
    }
  }, [_c('template', {
    slot: "AdvancedFilter"
  }, [_c('b-form', {
    ref: "form",
    staticClass: "offset-md-1",
    attrs: {
      "autocomplete": "off"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('detail-field', {
    staticClass: "col-md-6",
    attrs: {
      "label": "Intake",
      "field": "intake",
      "optionListApiUrl": '/contracts_intake/choice/',
      "rec": _vm.searchRec,
      "vvalidate": "ok",
      "validator": _vm.validator
    },
    on: {
      "enter": _vm.doFilter
    }
  }), _vm._v(" "), _c('detail-field', {
    staticClass: "col-md-6",
    attrs: {
      "label": "Type",
      "field": "scholarship_type",
      "optionListApiUrl": '/scholarships_type/choice/',
      "rec": _vm.searchRec,
      "vvalidate": "ok",
      "validator": _vm.validator
    },
    on: {
      "enter": _vm.doFilter
    }
  }), _vm._v(" "), _c('detail-field', {
    staticClass: "col-md-6",
    attrs: {
      "label": "Year",
      "field": "year",
      "optionListApiUrl": '/contracts_year/choice/',
      "rec": _vm.searchRec,
      "vvalidate": "ok",
      "validator": _vm.validator
    },
    on: {
      "enter": _vm.doFilter
    }
  })], 1)])], 1)], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-03834ba7"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Milestone/Overview.vue
// module id = 689
// module chunks = 1